<div *ngIf="spinner" class="preloader-backdrop">
    <div class="page-preloader">Loading</div>
</div>